import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translationsLogbookFormClearState } from 'reducers/translations/logbookForm/reducer'
import LogbookFormList from './LogbookFormList'
import LogbookFormItem from './LogbookFormItem'

function LogbookForm(props) {
  const {
    match: {
      params: { id },
    },
    translationsLogbookFormClearState,
  } = props
  const LogbookFormContent = id ? LogbookFormItem : LogbookFormList

  useEffect(
    () => () => {
      translationsLogbookFormClearState()
    },
    [],
  )

  return (
    <div className="content">
      <LogbookFormContent {...props} />
    </div>
  )
}

LogbookForm.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  translationsLogbookFormClearState: PropTypes.func.isRequired,
}

export default connect(null, {
  translationsLogbookFormClearState,
})(LogbookForm)
